import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'
import { Auth } from '@angular/fire/auth'
import { collectionData, collection, doc, docData, Firestore, orderBy, query, addDoc, serverTimestamp } from '@angular/fire/firestore'

import { Fresh, FreshTransform, Transform, TransformWithId } from '@innersight-os/shared/firestore-interfaces'
import { DocumentData } from '@firebase/firestore-types'


@Injectable({
  providedIn: 'root'
})
export class TransformsService {
  constructor(
    private auth: Auth,
    private db: Firestore,
  ) {}

  getTransforms = (operationId: string): Observable<TransformWithId[]> =>
    collectionData(
      query<TransformWithId, DocumentData>(
        // eslint-able-next-line @typescript-eslint/no-explicit-any
        collection(this.db, `operations/${operationId}/transforms`) as any,
        orderBy('createdAt', 'desc')
      ),
      {idField: 'id'},
    ) as Observable<TransformWithId[]>

  getTransform = (operationId: string, id: string): Observable<TransformWithId> =>
    docData<TransformWithId>(
      // eslint-able-next-line @typescript-eslint/no-explicit-any
      doc(this.db, `operations/${operationId}/transforms/${id}`) as any,
      {idField: 'id'},
    )

  async createTransform(transform: Fresh<Omit<Transform, 'createdAt' | 'createdBy'>>) {
    const freshTransform: FreshTransform = {
      ...transform,
      ...this.createdFields(),
    }

    return addDoc(
      collection(this.db, `operations/${transform.operationId}/transforms`),
      freshTransform,
    )
  }

  private createdFields = () => ({
    createdAt: serverTimestamp(),
    createdBy: this.auth.currentUser.uid,
  })
}
